import { atom } from 'recoil'

export type TenantAtomType = {
  country: string
  enabledFeatures: string[]
  onboarding: {
    country: string
  }
}

const DEFAULT_STATE = {
  country: '',
  enabledFeatures: [],
  onboarding: {
    country: '',
  },
}

export const tenantAtom = atom<TenantAtomType>({
  key: 'tenantState',
  default: DEFAULT_STATE,
})
